import React, { useState, useEffect } from 'react';
import assetsData from './AssetData.json'; // Adjust the path as needed
import { usePortfolio } from './../Context/PortfolioContext'; // Adjust the path as needed
import './AssetInput.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
const AssetInput = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [hoverStates, setHoverStates] = useState({}); // New hover states
    const { portfolioData, setPortfolioData } = usePortfolio();
    const [hoveredAsset, setHoveredAsset] = useState(null); // Track the currently hovered asset
    const [tooltipContent, setTooltipContent] = useState(''); // Content of the tooltip
    const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 }); // Position of the tooltip
    const [showTooltip, setShowTooltip] = useState(false);

    // Filter assets based on the search term
    const filteredAssets = assetsData.filter(asset =>
        asset.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const handleHover = (assetName, isHovering) => {
        setHoverStates(prev => ({ ...prev, [assetName]: isHovering }));
    };
    const handleAddAsset = (asset) => {
        // Prevent adding duplicates
        if (!portfolioData.selectedAssets.find(a => a.name === asset.name)) {
            setPortfolioData({
                ...portfolioData,
                selectedAssets: [...portfolioData.selectedAssets, asset]
            });
        }
    };
    const handleMouseEnter = (asset, event) => {
        const tooltipData = `Return: ${asset.return?.toFixed(2)}%, Volatility: ${asset.volatility?.toFixed(2)}%, ESG Score: ${asset.ESGscore?.toFixed(2)}`;
        setTooltipContent(tooltipData);
        setTooltipPosition({
            top: event.currentTarget.offsetTop, // Position tooltip according to the hovered item's top offset
            left: event.currentTarget.offsetLeft + event.currentTarget.offsetWidth // Position to the right of the hovered item
        });
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };
    const handleRemoveAsset = (assetName) => {
        setPortfolioData({
            ...portfolioData,
            selectedAssets: portfolioData.selectedAssets.filter(asset => asset.name !== assetName)
        });
    };

    return (
        <div class="asset-input-wrapper">
            <input
                className="search-input"
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search assets..."
            />
            <div className="assets-list">
                {filteredAssets.map((asset, index) => (
                    <div key={index} className="asset-item" 
                         onMouseEnter={() => handleHover(asset.name, true)}
                         onMouseLeave={() => handleHover(asset.name, false)}
                         onClick={() => handleAddAsset(asset)}>
                        {asset.name}
                        {hoverStates[asset.name] && (
                            <span className="tooltip">Return: {asset.return.toFixed(2)*100}%, Volatility: {asset.volatility.toFixed(2)*100}%</span>
                        )}
                    </div>
                ))}
            </div>
            <h3>Selected Assets:</h3>
            <ul className="selected-assets">
                {portfolioData.selectedAssets.map((asset, index) => (
                    <li key={index} className="selected-asset-item"
                        onMouseEnter={(e) => handleMouseEnter(asset, e)}
                        onMouseLeave={handleMouseLeave}>
                        <span>{asset.name}</span>
                        <button onClick={() => handleRemoveAsset(asset.name)} className="remove-asset-button">
                            <FontAwesomeIcon icon={faTimes} className="fa-icon" />
                        </button>
                    </li>
                ))}
            </ul>
            {showTooltip && (
                <div 
                    className="tooltip" 
                    style={{ position: 'absolute', top: tooltipPosition.top + 'px', left: tooltipPosition.left + 'px' }}>
                    {tooltipContent}
                </div>
            )}
            
        </div>

    );
};

export default AssetInput;
